import PaymentMethod from '@common/constants/PaymentMethod';

const PAGE_PAYMENT_TYPE_SELECTION = 'paymentTypeSelectionPage';
const PAGE_CARD_INPUT = 'cardInputPage';
const PAGE_BILLING_ADDRESS_ACH = 'cardBillingAddressPage';
const PAGE_BILLING_ADDRESS_CARD = 'achBillingAddressPage';
const PAGE_MICRO_DEPOSIT = 'microdepositPage';
const PAGE_DUPLICATE_WARNING = 'duplicateWarningPage';

const PLAID_ONBOARDING_FLOW = [PAGE_PAYMENT_TYPE_SELECTION, PAGE_BILLING_ADDRESS_ACH];

const PLAID_EDIT_FLOW = [PAGE_PAYMENT_TYPE_SELECTION];

const CARD_FLOW = [PAGE_PAYMENT_TYPE_SELECTION, PAGE_CARD_INPUT, PAGE_BILLING_ADDRESS_CARD];

const FLOWS = {
  onboarding: {
    [PaymentMethod.TYPE.BANK_ACCOUNT]: {
      [PaymentMethod.INPUT_TYPE.BANK_PLAID]: PLAID_ONBOARDING_FLOW,
    },
    [PaymentMethod.TYPE.CARD_CREDIT]: {
      [PaymentMethod.INPUT_TYPE.STRIPE_ELEMENT]: CARD_FLOW,
    },
    [PaymentMethod.TYPE.CARD_DEBIT]: {
      [PaymentMethod.INPUT_TYPE.STRIPE_ELEMENT]: CARD_FLOW,
    },
  },
  edit: {
    [PaymentMethod.TYPE.BANK_ACCOUNT]: {
      [PaymentMethod.INPUT_TYPE.BANK_PLAID]: PLAID_EDIT_FLOW,
    },
    [PaymentMethod.TYPE.CARD_CREDIT]: {
      [PaymentMethod.INPUT_TYPE.STRIPE_ELEMENT]: CARD_FLOW,
    },
    [PaymentMethod.TYPE.CARD_DEBIT]: {
      [PaymentMethod.INPUT_TYPE.STRIPE_ELEMENT]: CARD_FLOW,
    },
  },
};

function getPageFlow(fromDashboard, modeOfPayment, infoInputType) {
  const pageFlow = FLOWS[fromDashboard ? 'edit' : 'onboarding'][modeOfPayment][infoInputType];
  return pageFlow;
}

export {
  PAGE_PAYMENT_TYPE_SELECTION,
  PAGE_CARD_INPUT,
  PAGE_BILLING_ADDRESS_ACH,
  PAGE_BILLING_ADDRESS_CARD,
  PAGE_MICRO_DEPOSIT,
  PAGE_DUPLICATE_WARNING,
  getPageFlow,
};
